import type { ReactNode } from 'react'
import { cn } from 'cn'
import type { GifAttachment } from 'modules/community/types/post-attachment'

interface GifAttachmentPreviewProps {
  className?: string
  attachment: GifAttachment
}

export const GifAttachmentPreview = ({
  attachment,
  className,
}: GifAttachmentPreviewProps): ReactNode => (
  <div
    className={cn(
      'size-full overflow-hidden rounded-lg',
      !attachment.previewUrl && 'bg-bg-page',
      className,
    )}
  >
    {!!attachment.previewUrl && (
      <img
        src={attachment.previewUrl}
        alt=""
        className="size-full object-cover transition-all group-hover:scale-110"
      />
    )}
  </div>
)
